import { useEffect, useState } from "react";

const useCurrentLocation = () => {
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    address: "Fetching Location...",
    loading: true,
    error: null,
  });

  useEffect(() => {
    if (!navigator.geolocation) {
      setLocation((prev) => ({
        ...prev,
        loading: false,
        error: "Geolocation is not supported",
      }));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
          );

          const data = await response.json();

          const area =
            data.address.suburb ||
            data.address.neighbourhood ||
            data.address.city_district ||
            data.address.village ||
            data.address.town ||
            "";

          const city =
            data.address.city ||
            data.address.state_district ||
            data.address.state ||
            "";

          setLocation({
            latitude,
            longitude,
            address: `${area}, ${city}`,
            loading: false,
            error: null,
          });
        } catch (err) {
          setLocation({
            latitude,
            longitude,
            address: "Location unavailable",
            loading: false,
            error: err.message,
          });
        }
      },
      (error) => {
        setLocation({
          latitude: null,
          longitude: null,
          address: "Location unavailable",
          loading: false,
          error: error.message,
        });
      },
      {
        enableHighAccuracy: true,
      }
    );
  }, []);

  return location;
};

export default useCurrentLocation;